export const GTMCodes = () => {
    return {
        gtmScript: `(function (w, d, s, l, i) {
                w[l] = w[l] || [];
                w[l].push({
                    'gtm.start': new Date().getTime(),
                    event: 'gtm.js'
                });
                var f = d.getElementsByTagName(s)[0],
                    j = d.createElement(s),
                    dl = l != 'dataLayer' ? '&l=' + l : '';
                j.async = !0;
                j.src =
                    'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
                f.parentNode.insertBefore(j, f);
            })(window, document, 'script', 'dataLayer', 'GTM-MFFTC8V');`,
        gtmNoscript: `<noscript><iframe src="https://www.googletagmanager.com/ns.html?id=GTM-MFFTC8V"
            height="0" width="0" style="display:none;visibility:hidden"></iframe></noscript>`
    };
};